/** The Dr/Cr lines a statement row should display. */
export interface RowPostingView {
  lines: any[];
  editable: boolean;
  source: 'bank' | 'payment' | 'none';
}

/**
 * A statement row is recorded by its own bank voucher OR, when matched to an
 * invoice, by the payment voucher. The payment lines must be shown too — they
 * are the only place the bank side and the AR/AP side exist for a matched row.
 */
export function rowPostingView(tx: any): RowPostingView {
  if (tx?.posting?.lines?.length) {
    return { lines: collapsePostingLines(tx.posting.lines), editable: true, source: 'bank' };
  }
  if (tx?.payment_posting?.lines?.length) {
    return { lines: collapsePostingLines(tx.payment_posting.lines), editable: false, source: 'payment' };
  }
  return { lines: [], editable: false, source: 'none' };
}

/**
 * A combined payment writes one Cr line per settled invoice. The bank
 * transaction itself only has one Cr side per account, so display the sum:
 *   Cr 11201 65,600 + Cr 11201 47,360 + Cr 11201 36,800 -> Cr 11201 149,760
 * Distinct accounts/sides stay separate.
 */
export function collapsePostingLines(lines: any[]): any[] {
  const bySideAccount = new Map<string, any>();
  for (const line of lines) {
    const side = (Number(line.debit) || 0) > 0 ? 'Dr' : 'Cr';
    const key = `${side}:${line.account_code}`;
    const existing = bySideAccount.get(key);
    if (existing) {
      existing.debit = (Number(existing.debit) || 0) + (Number(line.debit) || 0);
      existing.credit = (Number(existing.credit) || 0) + (Number(line.credit) || 0);
    } else {
      bySideAccount.set(key, { ...line });
    }
  }
  return [...bySideAccount.values()];
}
